import jwtDecode, { JwtPayload } from "jwt-decode";
import jwt from '@/types/auth/jwt'

class JwtDataService {
    GetUsername(): string {
        let token = localStorage.getItem("ERA_Jwt");
        let decoded = jwtDecode<jwt>(token!);


        return decoded.Name;

    }

    isAuthenticated(): boolean {

       
        let token = localStorage.getItem("ERA_Jwt");
       
        if (token == null || token.length == 0) {
            return false;
        }
        let decoded = jwtDecode<jwt>(token!);

  if (decoded.exp.valueOf() > Math.round(Date.now() / 1000)) {
    return true;
} else {
    return false;
}

       


    }
GetImpersonatedBy(): string | null {
  const token = localStorage.getItem("ERA_Jwt");
  if (!token) return null;
  try {
    const decoded: any = jwtDecode(token);
    return decoded?.ImpersonatedBy || null;
  } catch {
    return null;
  }
}

isSuperAdmin(): boolean {
  const token = localStorage.getItem("ERA_Jwt");
  if (!token) return false;

  try {
    const decoded: any = jwtDecode(token);

    // verificăm dacă claim-ul există
    if (!decoded || decoded.SuperAdmin === undefined) return false;

    // convertim la boolean
    if (typeof decoded.SuperAdmin === "boolean") return decoded.SuperAdmin;
    if (typeof decoded.SuperAdmin === "string") return decoded.SuperAdmin.toLowerCase() === "true";

    return false;
  } catch (error) {
    return false;
  }
}

}


export default new JwtDataService();